<div [class]="styleClasses()">
	@for (column of sortedItems(); track $index) {
		<div class="flex flex-col gap-6">
			@for (item of column; track item) {
				<div
					class="rounded-xl bg-secondary-000 p-6 shadow-around outline outline-1 -outline-offset-1 outline-secondary-200 grid-item break-inside-avoid! print:h-auto print:max-h-fit"
				>
					<ng-container [ngTemplateOutlet]="item"></ng-container>
				</div>
			}
		</div>
	}
</div>
